jQuery(function ($) {


  /* horizontalScrollCol3Row2 width control */

  /*
    const C3R2Wrapper = $('#horizontalScrollCol3Row2   .item-wrapper');
    const C3R2Item = $('#horizontalScrollCol3Row2   .item-wrapper .item');
    const C3R2ItemW = C3R2Item.width();
    const C3R2ItemNumHf = C3R2Item.length / 2;


    $('#horizontalScrollCol3Row2   .item-wrapper').css('width', C3R2ItemW * C3R2ItemNumHf + (25 * C3R2ItemNumHf));
  */

  /* horizontalScrollCol3Row2 width control : SimpleBar int */
  /*
  new SimpleBar(document.getElementById('horizontalScrollCol3Row2'), {
    autoHide: false,
    forceVisible: true
  });

*/
  /* horizontalScrollCol5 width control : SimpleBar int */
  /*
  new SimpleBar(document.getElementById('horizontalScrollCol5'), {
    autoHide: false,
    forceVisible: true
  });

*/



  /* toggle action */
  /*
  $(".products--shopping-guide  .sentence > .headline").append(
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule = "evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg > '
  );
  */

  $(".products--shopping-guide  .sentence > .headline").on(
    "click",
    function () {
      let h = $(this).next().innerHeight();

      if ($(this).hasClass("is--active")) {
        $(this).parent().css("height", "44");
        $(this).removeClass("is--active");
      } else {
        $(this).addClass("is--active");
        $(this)
          .parent()
          .css("height", h + 60);
      }
    }
  );





  //Swiper int

  const swiper = new Swiper('#topMarquee', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    speed: 1000, //1秒かけながら次の画像へ移動
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      reverseDirection: false
    },
    navigation:{
      enabled: false
    },
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      750: {
        navigation: {
          enabled: true,
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0
      }
    }
  });

  // product point updater
  
  document.addEventListener('currentVariantUpdated', (e)=>{
    const pointsToUpdate = document.querySelector('.js-product-points');
    const userate = pointsToUpdate.dataset.useRate;
    const updatedPoints = Math.floor(e.detail.currentPrice / 100 * userate);
    pointsToUpdate.textContent=updatedPoints;
  });

});
